module.exports = __webpack_public_path__ + "static/013.thumb-3a0a4b50f401ac9b2307d0dc62a542c6.jpg";